import styled from 'styled-components'

export const GlobalSearchLoadingItemStyled = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.medium};
  width: 100%;
  padding: ${(props) =>
    `${props.theme.typography.pxToRem(12)} ${props.theme.space.medium}`};
`
